const LABELS = {
  junk: "Junk removal",
  drywall: "Drywall repair",
  furniture: "Furniture assembly",
  handyman: "Handyman",
  transport: "Delivery / Transport",
  furniture_delivery: "Furniture Depot delivery",
};

export const serviceLabel = (st) => LABELS[st] || String(st || "").replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
